module.exports = __webpack_public_path__ + "static/media/MaisonNeue-Demi.8a1f7d84.eot";